var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 26,
    viewBox: "0 0 132 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.719 13.0616C116.041 12.5999 115.303 12.292 114.564 11.8918C114.102 11.6455 113.61 11.3993 113.209 11.0606C112.532 10.5065 112.655 9.39828 113.394 8.90573C114.41 8.22847 116.103 8.59789 116.288 9.98319C116.288 10.014 116.319 10.0448 116.349 10.0448H117.889C117.919 10.0448 117.95 10.014 117.95 9.98319C117.858 9.02887 117.488 8.22847 116.811 7.70513C116.165 7.21258 115.426 6.96631 114.625 6.96631C110.562 6.96631 110.192 11.2761 112.378 12.6306C112.624 12.7846 114.779 13.862 115.549 14.3546C116.319 14.8163 116.534 15.6783 116.226 16.3556C115.918 16.9713 115.149 17.4022 114.379 17.3407C113.517 17.2791 112.871 16.8173 112.624 16.1093C112.594 15.9862 112.563 15.7399 112.563 15.6167C112.563 15.586 112.532 15.5552 112.501 15.5552H110.839C110.808 15.5552 110.777 15.586 110.777 15.6167C110.777 16.8173 111.085 17.4946 111.886 18.1103C112.655 18.6952 113.486 18.9415 114.379 18.9415C116.657 18.9415 117.827 17.6485 118.073 16.3248C118.258 15.0318 117.889 13.862 116.719 13.0616Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1601 7.21265H43.4212H42.6208C42.5901 7.21265 42.5593 7.24343 42.5593 7.24343L41.174 11.7687C41.1432 11.8303 41.0816 11.8303 41.0508 11.7687L39.6655 7.24343C39.6655 7.21264 39.6347 7.21265 39.604 7.21265H38.8036H38.0647H37.0796C37.0489 7.21265 37.0181 7.24343 37.0181 7.27421V18.8184C37.0181 18.8492 37.0489 18.88 37.0796 18.88H38.742C38.7728 18.88 38.8036 18.8492 38.8036 18.8184V10.0448C38.8036 9.98325 38.8959 9.95246 38.9267 10.014L40.312 14.5701L40.4044 14.878C40.4044 14.9088 40.4351 14.9088 40.4659 14.9088H41.7589C41.7897 14.9088 41.8204 14.878 41.8204 14.878L41.9128 14.5701L43.2981 10.014C43.3289 9.95246 43.4212 9.95246 43.4212 10.0448V18.8184C43.4212 18.8492 43.452 18.88 43.4828 18.88H45.1452C45.1759 18.88 45.2067 18.8492 45.2067 18.8184V7.27421C45.2067 7.24343 45.1759 7.21265 45.1452 7.21265H44.1601Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.137 7.21265C91.1062 7.21265 91.0754 7.24343 91.0754 7.24343L89.6901 11.7687C89.6593 11.8303 89.5978 11.8303 89.567 11.7687L88.1817 7.24343C88.1817 7.21264 88.1509 7.21265 88.1201 7.21265H85.565C85.5342 7.21265 85.5034 7.24343 85.5034 7.27421V18.8184C85.5034 18.8492 85.5342 18.88 85.565 18.88H87.2273C87.2581 18.88 87.2889 18.8492 87.2889 18.8184V10.0448C87.2889 9.98325 87.3813 9.95246 87.4121 10.014L88.7974 14.5701L88.8897 14.878C88.8897 14.9088 88.9205 14.9088 88.9513 14.9088H90.2442C90.275 14.9088 90.3058 14.878 90.3058 14.878L90.3981 14.5701L91.7834 10.014C91.8142 9.95246 91.9066 9.95246 91.9066 10.0448V18.8184C91.9066 18.8492 91.9374 18.88 91.9682 18.88H93.6305C93.6613 18.88 93.6921 18.8492 93.6921 18.8184V7.27421C93.6921 7.24343 93.6613 7.21265 93.6305 7.21265H91.137Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5884 7.21265H66.4792H64.8168H61.6768C61.646 7.21265 61.6152 7.24343 61.6152 7.27421V8.72108C61.6152 8.75187 61.646 8.78265 61.6768 8.78265H64.7245V18.8184C64.7245 18.8492 64.7553 18.88 64.786 18.88H66.4484C66.4792 18.88 66.51 18.8492 66.51 18.8184V8.78265H69.5576C69.5884 8.78265 69.6192 8.75187 69.6192 8.72108V7.27421C69.65 7.24343 69.6192 7.21265 69.5884 7.21265Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4393 18.8802H80.9477C80.9785 18.8802 81.0093 18.8494 81.0093 18.7879L77.8693 7.21292C77.8693 7.18213 77.8385 7.18213 77.8077 7.18213H77.2228H76.2069H75.622C75.5912 7.18213 75.5604 7.21292 75.5604 7.21292L72.4204 18.7879C72.4204 18.8187 72.4512 18.8802 72.482 18.8802H73.9904C74.0212 18.8802 74.052 18.8494 74.052 18.8494L74.9755 15.4631C74.9755 15.4324 75.0063 15.4324 75.0371 15.4324H78.3926C78.4234 15.4324 78.4542 15.4631 78.4542 15.4631L79.3777 18.8494C79.3777 18.8494 79.4085 18.8802 79.4393 18.8802ZM75.4373 13.77L76.6687 9.24469C76.6995 9.18312 76.761 9.18312 76.7918 9.24469L78.0232 13.77C78.0232 13.8008 77.9924 13.8624 77.9616 13.8624H75.5296C75.4681 13.8624 75.4373 13.8008 75.4373 13.77Z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.36 18.8802H106.868C106.899 18.8802 106.93 18.8494 106.93 18.7879L103.79 7.21292C103.79 7.18213 103.759 7.18213 103.728 7.18213H103.143H102.127H101.542C101.512 7.18213 101.481 7.21292 101.481 7.21292L98.3408 18.7879C98.3408 18.8187 98.3716 18.8802 98.4024 18.8802H99.9108C99.9416 18.8802 99.9724 18.8494 99.9724 18.8494L100.896 15.4631C100.896 15.4324 100.927 15.4324 100.957 15.4324H104.313C104.344 15.4324 104.375 15.4631 104.375 15.4631L105.298 18.8494C105.298 18.8494 105.329 18.8802 105.36 18.8802ZM101.358 13.77L102.589 9.24469C102.62 9.18312 102.681 9.18312 102.712 9.24469L103.944 13.77C103.944 13.8008 103.913 13.8624 103.882 13.8624H101.45C101.388 13.8624 101.358 13.8008 101.358 13.77Z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9793 17.156V13.585C51.9793 13.5542 52.0101 13.5235 52.0409 13.5235H56.5047C56.5354 13.5235 56.5662 13.4927 56.5662 13.4619V12.015C56.5662 11.9842 56.5354 11.9535 56.5047 11.9535H52.0409C52.0101 11.9535 51.9793 11.9227 51.9793 11.8919V8.84422C51.9793 8.81343 52.0101 8.78265 52.0409 8.78265H57.0896C57.1204 8.78265 57.1511 8.75187 57.1511 8.72108V7.27421C57.1511 7.24343 57.1204 7.21265 57.0896 7.21265H51.9793H50.2554C50.2246 7.21265 50.1938 7.24343 50.1938 7.27421V8.78265V11.9842V13.5542V17.2484V18.8184C50.1938 18.8492 50.2246 18.88 50.2554 18.88H51.9793H57.3051C57.3358 18.88 57.3666 18.8492 57.3666 18.8184V17.3099C57.3666 17.2792 57.3358 17.2484 57.3051 17.2484H52.0101C52.0101 17.2176 51.9793 17.1868 51.9793 17.156Z",
    fill: "#161616"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.988 18.7571L126.201 12.7849C126.17 12.7541 126.17 12.7233 126.201 12.6925L131.403 7.27448C131.434 7.2437 131.403 7.18213 131.372 7.18213H129.248C129.218 7.18213 129.218 7.18213 129.218 7.21292L124.785 11.8306C124.754 11.8614 124.692 11.8306 124.692 11.7998V7.30526C124.692 7.27448 124.661 7.2437 124.631 7.2437H122.938C122.907 7.2437 122.876 7.27448 122.876 7.30526V18.8494C122.876 18.8802 122.907 18.911 122.938 18.911H124.6C124.631 18.911 124.661 18.8802 124.661 18.8494V13.77C124.661 13.7084 124.723 13.6776 124.754 13.7392L129.741 18.911L129.772 18.9418H131.896C131.988 18.8802 132.019 18.7879 131.988 18.7571Z",
    fill: "#161616"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5963 0.993896L15.499 8.5053L17.3769 4.07234L25.5963 0.993896Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2627 0.993896L12.2984 8.56687L10.5129 4.07234L2.2627 0.993896Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9649 18.387L19.2559 22.5121L25.0433 24.1129L26.6749 18.4793L21.9649 18.387Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21582 18.4793L2.8474 24.1129L8.60409 22.5121L5.92584 18.387L1.21582 18.4793Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29561 11.4298L6.69482 13.8618L12.3899 14.1081L12.2052 7.95117L8.29561 11.4298Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5943 11.4299L15.6231 7.88965L15.5 14.1081L21.1951 13.8618L19.5943 11.4299Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.604 22.5122L12.0519 20.8499L9.06577 18.5103L8.604 22.5122Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8389 20.8499L19.2559 22.5122L18.7942 18.5103L15.8389 20.8499Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2559 22.5125L15.8389 20.8501L16.1159 23.0666L16.0851 24.0209L19.2559 22.5125Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60449 22.5125L11.8061 24.0209L11.7753 23.0666L12.0524 20.8501L8.60449 22.5125Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8669 17.033L9.00391 16.2019L11.0049 15.2783L11.8669 17.033Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0229 17.033L16.8541 15.2783L18.8859 16.2019L16.0229 17.033Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60403 22.5123L9.09658 18.3872L5.92578 18.4796L8.60403 22.5123Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7935 18.3872L19.2552 22.5123L21.9643 18.4796L18.7935 18.3872Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1951 13.8618L15.5 14.1081L16.0233 17.0326L16.8545 15.2779L18.8863 16.2014L21.1951 13.8618Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00463 16.2014L11.0056 15.2779L11.8676 17.0326L12.3909 14.1081L6.6958 13.8618L9.00463 16.2014Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69531 13.8621L9.06571 18.5105L9.00415 16.2017L6.69531 13.8621Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8863 16.2017L18.7939 18.5105L21.1951 13.8621L18.8863 16.2017Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3905 14.1082L11.8672 17.0327L12.5137 20.5113L12.6676 15.9244L12.3905 14.1082Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 14.1082L15.2227 15.9244L15.3458 20.5113L16.0231 17.0327L15.4997 14.1082Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0225 17.0326L15.3452 20.5112L15.8378 20.8499L18.7931 18.5102L18.8854 16.2014L16.0225 17.0326Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00391 16.2014L9.06547 18.5102L12.0516 20.8499L12.5133 20.5112L11.8669 17.0326L9.00391 16.2014Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0841 24.0211L16.1149 23.0668L15.8379 22.8513H12.0206L11.7743 23.0668L11.8051 24.0211L8.60352 22.5127L9.71176 23.4362L11.9898 25.0062H15.8686L18.1467 23.4362L19.2549 22.5127L16.0841 24.0211Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8384 20.8501L15.3459 20.5115H12.5137L12.052 20.8501L11.7749 23.0666L12.0212 22.8511H15.8384L16.1155 23.0666L15.8384 20.8501Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.028 8.99785L26.89 4.84195L25.5971 0.993896L15.8384 8.25903L19.5941 11.4298L24.889 12.9691L26.0588 11.6145L25.5663 11.2451L26.3667 10.5063L25.751 10.0137L26.5514 9.39805L26.028 8.99785Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.84195L1.86196 8.99785L1.30784 9.39805L2.10824 10.0137L1.49255 10.5063L2.32373 11.2451L1.8004 11.6145L2.97021 12.9691L8.29591 11.4298L12.0516 8.25903L2.26216 0.993896L1 4.84195Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8888 12.9692L19.5939 11.4299L21.1946 13.8619L18.7935 18.5104L21.9643 18.4796H26.6743L24.8888 12.9692Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29576 11.4299L2.97005 12.9692L1.21533 18.4796H5.92535L9.06537 18.5104L6.69496 13.8619L8.29576 11.4299Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 14.1082L15.8384 8.2592L17.3776 4.07251H10.5127L12.0519 8.2592L12.3905 14.1082L12.5137 15.9553V20.5114H15.3459V15.9553L15.4998 14.1082Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.237313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.792beb4049aa23b2bfd79b62d60f12ed.svg";
export { ForwardRef as ReactComponent };